import "../styles//Ourservices.css";

const Ourservices=()=>{
    return(
        <div className="page2">
            <h1 className="our">Our Services</h1>

            <div className="Services">
                <div className="content" id='autoshow'>
                    <div className="img1"></div>
                    <h2 className="txt1">CNC Turning</h2>
                </div>
                <div className="content" id='autoshow'>
                    <div className="img2"></div>
                    <h2 className="txt1">CNC Turning</h2>
                </div>
                <div className="content" id='autoshow'>
                    <div className="img3"></div>
                    <h2 className="txt1">VMC Milling</h2>
                </div>
            </div>
        </div>
    );
}
export default Ourservices;